module.exports = __webpack_public_path__ + "img/bankB-gold.48df38b4.svg";